module.exports = __webpack_public_path__ + "img/yh.967603c4.png";